module.exports = __webpack_public_path__ + "static/media/BAKE-BNB.be3990df.png";